// Console cleanup utility
// Suppress specific console warnings that are not critical for development

const originalConsoleWarn = console.warn;
const originalConsoleError = console.error;

console.warn = function(...args) {
  const message = args.join(' ');
  
  // Suppress resource preload warnings
  if (message.includes('was preloaded using link preload but not used')) {
    return;
  }
  
  // Suppress PayPal SDK warnings that are not critical
  if (message.includes('PayPal') && (
    message.includes('funding') || 
    message.includes('preload') ||
    message.includes('insight')
  )) {
    return;
  }
  
  // Call original console.warn for other messages
  originalConsoleWarn.apply(console, args);
};

console.error = function(...args) {
  const message = args.join(' ');
  
  // Suppress non-critical errors
  if (message.includes('Turn on Console insight') || 
      message.includes('preloaded using link preload')) {
    return;
  }
  
  // Call original console.error for critical errors
  originalConsoleError.apply(console, args);
};

// Global error handler for unhandled promise rejections
window.addEventListener('unhandledrejection', function(event) {
  const error = event.reason;
  const errorMessage = error?.message || error?.toString() || '';
  
  // Suppress browser extension and third-party script errors
  if (
    errorMessage.includes('message channel closed') ||
    errorMessage.includes('Extension context invalidated') ||
    errorMessage.includes('listener indicated an asynchronous response') ||
    errorMessage.includes('chrome-extension://') ||
    errorMessage.includes('moz-extension://') ||
    errorMessage.includes('safari-extension://')
  ) {
    event.preventDefault();
    return;
  }
  
  // Let other errors through
  console.error('Unhandled promise rejection:', error);
});

// Global error handler for uncaught errors
window.addEventListener('error', function(event) {
  const error = event.error;
  const errorMessage = error?.message || error?.toString() || '';
  
  // Suppress browser extension and vendor script errors
  if (
    errorMessage.includes('message channel closed') ||
    errorMessage.includes('Extension context invalidated') ||
    errorMessage.includes('listener indicated an asynchronous response') ||
    event.filename?.includes('chrome-extension://') ||
    event.filename?.includes('moz-extension://') ||
    event.filename?.includes('safari-extension://') ||
    event.filename?.includes('vendor.js')
  ) {
    event.preventDefault();
    return;
  }
  
  // Let other errors through
  console.error('Uncaught error:', error);
});

export default {};